export const GET_LIST_BANK_TAXES      = 'GET_LIST_BANK_TAXES';
export const CHANGE_VALUE_INPUT_TAXES = 'CHANGE_VALUE_INPUT_TAXES';
export const SAVE_BANK_TAX            = 'SAVE_BANK_TAX';
export const GET_INFO_BANK_TAX        = 'GET_INFO_BANK_TAX';
export const DELETE_BANK_TAX          = 'DELETE_BANK_TAX';
export const UPLOAD_IMAGE_BANK_TAX    = 'UPLOAD_IMAGE_BANK_TAX';
export const BANK_TAX_DEFAULT         = 'BANK_TAX_DEFAULT';